export const generateId = function () {
  return Math.floor(
    Math.random() * 100000 + Math.random() * 20000 + Math.random() * 5000
  );
};

export const deepClone = function (origin) {
  if (origin === undefined) {
    return undefined;
  }

  return JSON.parse(JSON.stringify(origin));
};

export const getContainerByType = (arr, typeName) => {
  let foundCon = null;
  arr.forEach((con) => {
    if (!!con.category && !!con.type && con.type === typeName) {
      foundCon = con;
    }
  });
  return foundCon;
};

export const importAll = (r) => {
  let __modules = {};
  r.keys().forEach((key) => {
    let m = r(key).default;
    let n = m.name;
    __modules[n] = m;
  });
  return __modules;
};

